/**
 * Нижняя навигация для worker-app
 */
import './BottomNav.css'

type NavTab = 'qr' | 'sites' | 'schedule' | 'profile'

interface BottomNavProps {
  activeTab: NavTab
  onTabChange: (tab: NavTab) => void
}

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  return (
    <nav className="bottom-nav">
      <button 
        className={`bottom-nav-item ${activeTab === 'qr' ? 'active' : ''}`}
        onClick={() => onTabChange('qr')}
      >
        <span className="bottom-nav-icon">📱</span>
        <span className="bottom-nav-label">Пропуск</span>
      </button>
      
      <button 
        className={`bottom-nav-item ${activeTab === 'sites' ? 'active' : ''}`}
        onClick={() => onTabChange('sites')}
      >
        <span className="bottom-nav-icon">🏢</span>
        <span className="bottom-nav-label">Объекты</span>
      </button>
      
      <button 
        className={`bottom-nav-item ${activeTab === 'schedule' ? 'active' : ''}`}
        onClick={() => onTabChange('schedule')}
      >
        <span className="bottom-nav-icon">📅</span>
        <span className="bottom-nav-label">График</span>
      </button>
      
      <button 
        className={`bottom-nav-item ${activeTab === 'profile' ? 'active' : ''}`}
        onClick={() => onTabChange('profile')}
      >
        <span className="bottom-nav-icon">👤</span>
        <span className="bottom-nav-label">Профиль</span>
      </button>
    </nav>
  )
}

